module.exports = __webpack_public_path__ + "img/left-flower.8e0d6b39.png";